/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

$(document).ready(function ($) {  

	/* GLOBALS */

	var mouseX;
	var mouseY;
	$(document).mousemove( function(e) {
	   mouseX = e.pageX; 
	   mouseY = e.pageY;
	});  

	var $mapAreas = { "AL":"Alabama",
					"AK":"Alaska",
					"AZ":"Arizona",
					"AR":"Arkansas",
					"CA":"California",
					"CO":"Colorado",
					"CT":"Connecticut",
					"DE":"Delaware",
					"FL":"Florida",
					"GA":"Georgia",
					"HI":"Hawaii",
					"ID":"Idaho",
					"IL":"Illinois",
					"IN":"Indiana",
					"IA":"Iowa",
					"KS":"Kansas",
					"KY":"Kentucky",
					"LA":"Louisiana",
					"ME":"Maine",
					"MD":"Maryland",
					"MA":"Massachusetts",
					"MI":"Michigan",
					"MN":"Minnesota",
					"MS":"Mississippi",
					"MO":"Missouri",
					"MT":"Montana",
					"NE":"Nebraska",
					"NV":"Nevada",
					"NH":"New Hampshire",
					"NJ":"New Jersey",
					"NM":"New Mexico",
					"NY":"New York",
					"NC":"North Carolina",
					"ND":"North Dakota",
					"OH":"Ohio",
					"OK":"Oklahoma",
					"OR":"Oregon",
					"PA":"Pennsylvania",
					"RI":"Rhode Island",
					"SC":"South Carolina",
					"SD":"South Dakota",
					"TN":"Tennessee",
					"TX":"Texas",
					"UT":"Utah",
					"VT":"Vermont",
					"VA":"Virginia",
					"WA":"Washington",
					"WV":"West Virginia",
					"WI":"Wisconsin",
					"WY":"Wyoming",
					"American_Samoa":"American Samoa",
					"Guam":"Guam",
					"Marshall_Islands":"Marshall Islands",
					"Micronesia":"Micronesia",
					"Northern_Marinara_Islands":"Northern Mariana Islands",
					"PALAU":"Palau",
					"Puerto_Rico":"Puerto Rico",
					"US_Virgin_Islands":"US Virgin Islands"
					};


	/* set with and height of map */

	// we need this so the maps width is 100% in IE 11

	if ( $('.state-landing').length ) {

		$(window).resize(function() {

			var svgW = $('.state-landing .right').width(),
				svgH = svgW / .87039; // calculation to keep the map ratio

			$('svg#Layer_1').attr({ 'width' : svgW, 'height' : svgH });

		}).trigger('resize');
		
	}

	/*
		Navigation Toggles
	*/

	$('#hamburger').click(function(){
		$(this).toggleClass('open');
		$('.main-navigation').toggleClass('open');
	}); 

	$('.dropdown-toggle').each(function(){
		$(this).click(function(){
			$(this).siblings('.dropdown-target').toggleClass('open');
		});
	});

	$('#site-search__toggle').add('#close-me').click(function(){

		if( !$('#search-form__lightbox').hasClass("visible") ){
			$('#search-form__lightbox').toggleClass("visible", true);

			$('#search-form__lightbox').animate({
				"max-height": "300px",
			    opacity: 1,
			    padding: "1.25rem 1rem"
			}, 250, function() {
			});
		} else {
			$('#search-form__lightbox').animate({
				"max-height": "0px",
			    opacity: 0,
			    padding: "1rem 1rem"
		  	}, 250, function() {
				$('#search-form__lightbox').toggleClass("visible", false);
		  	});
		}
	});

	/*
		Parallax Scroll Hero Controller
	*/

	var $heroContainerImage = $('#hero-image__container div');
		
	if ( $heroContainerImage.length ) {

		$(window).scroll(function(){
			
			if($(window).scrollTop() > 0 ){

				$top = $(window).scrollTop()/2;
				$bottom = 0 - $(window).scrollTop()/2;

				$heroContainerImage.css({"margin-top": $top , "margin-bottom": $bottom });

			}
			else {

				$heroContainerImage.css({"margin-top": 0 , "margin-bottom": 0 });

			}

		});

	}

	/* 
		State or Territory Click 
	*/
	$('#outlines path').add('#outlines polygon').add('#Territories g').click(function() {
		$identifier = $mapAreas[$(this).attr('id')].replace(' ', '-');
		if($("a#region-"+$identifier).length){
			$("a#region-"+$identifier)[0].click();
		}
	});	


	/* 
		State or Territory Hover 
	*/

	$('#outlines path').add('#outlines polygon').add('#Territories g').mouseover(function() {
		$('#map-tooltip').text($mapAreas[$(this).attr('id')]);
	 	$('#map-tooltip').css({'top':mouseY - 200 ,'left':mouseX - 50 });
	});

	$('#outlines path').add('#outlines polygon').add('#Territories g').mouseout(function() {
	 	$('#map-tooltip').css({ 'top': -200, 'left': -200 });
	});



	/*
		At A Glance Slide
	*/

	var width = $(document).width(),
		$slideshow = $('.slideshow');

	// on page load init slider but first wrap slides if window width is 900px or wider
	if (width >= 900) {
		
		// init the slider if slider only if needed
		wrapSlideshowSlides();
		initSlideshow();
		
	}
	else {
		
		initSlideshow();

	}

	$(window).resize(function() {

		width = $(document).width();

		// on page load init slider but first wrap slides if window width is 900px or wider
		if (width >= 900) {
			
			// init the slider if slider only if needed
			if ( $('.desktop-slides-wrap').length ) {
				return;
			}	
			else {
				destroySlideshow();
				wrapSlideshowSlides();
				initSlideshow();
			}

		}
		else {
			
			if ( $('.desktop-slides-wrap').length ) {
				destroySlideshow();
				unwrapSlides();
				initSlideshow();
			}
			else {
				return;
			}

		}

	});

	function wrapSlideshowSlides() {
		
		var atAGlanceDivs = $(".slideshow .slide");
	
		for ( var i = 0; i < atAGlanceDivs.length; i+=10 ) {
			
			atAGlanceDivs.slice(i, i+10).wrapAll("<div class='desktop-slides-wrap'></div>");

		}

	}

	var slideDivName;

	function initSlideshow() {
		
	    if (width >= 900) {

	    	slideDivName = '.desktop-slides-wrap';

		}
		else {

			slideDivName = '.slide';

		}
		
		if($slideshow.length>0) {
			$slideshow.cycle({
				fx: 'carousel',
		        timeout: 0,
		        carouselVisible: 1,
		        next: '#next',
		        prev: '#prev',
		        pager: '#pager',
		        slides: slideDivName,
		        carouselFluid: true,
		        log: false
		    });
		}
	}

	function destroySlideshow() {
		if($slideshow.length>0) {
			$slideshow.cycle('destroy');
		}
	}

	function unwrapSlides() {
		$('.slide').unwrap();
	}

	/********************************
		Facet loader scroll to top
	********************************/

	$(document).on('facetwp-loaded', function() {
        if (FWP.loaded) {
            $('html, body').animate({
                scrollTop: $('.facetwp-template').offset().top - 275
            }, 500);
        }
    });

    // Carousel plugin
	// $(function() {
	    $('.jcarousel')
	        .jcarousel({
	            wrap: 'circular'
	        })
	        .jcarouselAutoscroll({
	            interval: 5000,
	            target: '+=1',
	            autostart: true
	        })
	    ;
	// });

     $('.jcarousel-control-prev')
            .on('jcarouselcontrol:active', function() {
                $(this).removeClass('inactive');
            })
            .on('jcarouselcontrol:inactive', function() {
                $(this).addClass('inactive');
            })
            .jcarouselControl({
                target: '-=1'
            });

        $('.jcarousel-control-next')
            .on('jcarouselcontrol:active', function() {
                $(this).removeClass('inactive');
            })
            .on('jcarouselcontrol:inactive', function() {
                $(this).addClass('inactive');
            })
            .jcarouselControl({
                target: '+=1'
            });

        $('.jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .jcarouselPagination();

    // $.jStorage.set("popup", "unseen");

    // Feedback form rating 
    $('.gfield_radio .gchoice input').change (function (e) {
    	var parent = $(e.target).parents('.gchoice'); 
    	parent.prevAll().addClass('selected');
    	parent.addClass('selected');
    	parent.nextAll().removeClass('selected');
    })

	// CEO Subscribe Popup
	var modal = $('#ceoSubscribePopup');
	var subscribe = $("#ceoSubscribeBtn");
	var close = $("#ceoSubscribePopup .close");

	subscribe.on('click', function(){
		modal.show();
	})

	close.on('click', function(){
		modal.hide();
	})

	window.onclick = function(event) {
	  if (event.target == modal) {
	    modal.hide();
	  }
	} 

});